import { lazy } from 'react';
import inventoryPath from 'src/constants/urlPath/erp/inventoryPath';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../../layouts/NewFeatures/MainLayout';
import { PermissionEn } from '@martech-solution/utils/constants';
import { HRTicketCategoryEn } from 'src/types/master_data/hrTicketCategory.type';

const Inventory = lazy(() => import('src/pages/Inventory'));

const BinLocation = lazy(() => import('src/pages/MasterData/BinLocation'));
const BinLocationForm = lazy(() => import('src/pages/MasterData/BinLocation/AddBinLocation'));
const BinLocationQR = lazy(() => import('src/pages/MasterData/BinLocation/BinLocationQrCode'));

const ITR = lazy(() => import('src/pages/Inventory/ITR'));
const ITRForm = lazy(() => import('src/pages/Inventory/ITR/ITRForm'));

const GRPOR = lazy(() => import('src/pages/Purchase/GRPOR'));
const AddGRPOR = lazy(() => import('src/pages/Purchase/GRPOR/AddGRPOR'));

const IT = lazy(() => import('src/pages/Inventory/IT'));
const ITForm = lazy(() => import('src/pages/Inventory/IT/ITForm'));

const GRPO = lazy(() => import('src/pages/Inventory/GRPO'));
const AddGRPO = lazy(() => import('src/pages/Inventory/GRPO/AddGRPO'));

const InventoryJournal = lazy(() => import('src/pages/ERP/Planning/InventoryJournal'));

const inventoryRoutes: RouteType[] = [
  {
    path: inventoryPath.inventory,
    Layout: NewLayout,

    Component: Inventory
  },
  // BinLocation -
  {
    path: inventoryPath.binLocation,
    Layout: NewLayout,
    Component: BinLocation,
    checkPath: inventoryPath.binLocation,
    permission: PermissionEn.read
  },
  {
    path: `${inventoryPath.binLocationDetail}/:id`,
    Layout: NewLayout,
    Component: BinLocationForm,
    checkPath: inventoryPath.binLocation,
    permission: PermissionEn.viewDetail
  },
  {
    path: inventoryPath.binLocationAdd,
    Layout: NewLayout,
    Component: BinLocationForm,
    checkPath: inventoryPath.binLocation,
    permission: PermissionEn.create
  },
  {
    path: `${inventoryPath.binLocationEdit}/:id`,
    Layout: NewLayout,
    Component: BinLocationForm,
    checkPath: inventoryPath.binLocation,
    permission: PermissionEn.update
  },
  {
    path: `${inventoryPath.binLocationQR}`,
    Layout: NewLayout,
    Component: BinLocationQR,
    checkPath: inventoryPath.binLocation,
    permission: PermissionEn.viewDetail
  },
  // ITR - Phiếu yêu cầu chuyển kho
  {
    path: inventoryPath.itr,
    Layout: NewLayout,
    Component: ITR,
    checkPath: inventoryPath.itr,
    permission: PermissionEn.read
  },
  {
    path: `${inventoryPath.itrDetail}/:id`,
    Layout: NewLayout,
    Component: ITRForm,
    checkPath: inventoryPath.itr,
    permission: PermissionEn.viewDetail
  },
  {
    path: inventoryPath.itrAdd,
    Layout: NewLayout,
    Component: ITRForm,
    checkPath: inventoryPath.itr,
    permission: PermissionEn.create
  },
  {
    path: `${inventoryPath.itrEdit}/:id`,
    Layout: NewLayout,
    Component: ITRForm,
    checkPath: inventoryPath.itr,
    permission: PermissionEn.update
  },
  // GRPOR - Yêu cầu nhập kho
  {
    path: inventoryPath.grpor,
    Layout: NewLayout,
    Component: GRPOR,
    permission: PermissionEn.read
  },
  {
    path: inventoryPath.grporAdd,
    Layout: NewLayout,
    checkPath: inventoryPath.grpor,
    Component: AddGRPOR,
    permission: PermissionEn.create,
    ticketCategoryCode: HRTicketCategoryEn.GOOD_RECEIPT_PO_REQUEST
  },
  {
    path: `${inventoryPath.grporEdit}/:id`,
    Layout: NewLayout,
    checkPath: inventoryPath.grpor,
    Component: AddGRPOR,
    permission: PermissionEn.update,
    ticketCategoryCode: HRTicketCategoryEn.GOOD_RECEIPT_PO_REQUEST
  },
  {
    path: `${inventoryPath.grporDetail}/:id`,
    Layout: NewLayout,
    checkPath: inventoryPath.grpor,
    Component: AddGRPOR,
    permission: PermissionEn.viewDetail,
    ticketCategoryCode: HRTicketCategoryEn.GOOD_RECEIPT_PO_REQUEST
  },

  // IT - Phiếu chuyển kho
  {
    path: inventoryPath.it,
    Layout: NewLayout,
    Component: IT,
    checkPath: inventoryPath.it,
    permission: PermissionEn.read
  },
  {
    path: inventoryPath.itAdd,
    Layout: NewLayout,
    Component: ITForm,
    checkPath: inventoryPath.it,
    permission: PermissionEn.create
  },
  {
    path: `${inventoryPath.itEdit}/:id`,
    Layout: NewLayout,
    Component: ITForm,
    checkPath: inventoryPath.it,
    permission: PermissionEn.update
  },
  {
    path: `${inventoryPath.itDetail}/:id`,
    Layout: NewLayout,
    Component: ITForm,
    checkPath: inventoryPath.it,
    permission: PermissionEn.viewDetail
  },
  // Xem tồn kho
  {
    path: inventoryPath.inventoryJournal,
    Layout: NewLayout,
    Component: InventoryJournal
  },
  // GRPO - Yêu cầu nhập kho
  {
    path: inventoryPath.grpo,
    Layout: NewLayout,
    Component: GRPO,
    permission: PermissionEn.read
  },
  {
    path: inventoryPath.grpoAdd,
    Layout: NewLayout,
    checkPath: inventoryPath.grpo,
    Component: AddGRPO,
    ticketCategoryCode: HRTicketCategoryEn.GOOD_RECEIPT_PO,
    permission: PermissionEn.create
  },
  {
    path: `${inventoryPath.grpoEdit}/:id`,
    Layout: NewLayout,
    checkPath: inventoryPath.grpo,
    Component: AddGRPO,
    ticketCategoryCode: HRTicketCategoryEn.GOOD_RECEIPT_PO,
    permission: PermissionEn.update
  },
  {
    path: `${inventoryPath.grpoDetail}/:id`,
    Layout: NewLayout,
    checkPath: inventoryPath.grpo,
    Component: AddGRPO,
    ticketCategoryCode: HRTicketCategoryEn.GOOD_RECEIPT_PO,
    permission: PermissionEn.viewDetail
  }
];

export default inventoryRoutes;
